<template>
  <button
    @click="toggle"
    :class="value ? 'bg-azuloscuro text-white' : 'bg-white text-azuloscuro'"
    class="px-4 py-3 rounded-full border border-gray-300 mr-1 mb-2 focus:outline-none text-xs"
  >{{category}}</button>
</template>

<script>
export default {
  props: ['value', 'category'],
  methods: {
    toggle() {
      this.$emit("input", !this.value);
    }
  }
};
</script>
